// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Transfer_paper__97jXz{
        max-width: 300px; 
        height: 300px; 
        overflow: auto; 
        margin-top: 15px;
    }
  
    .Transfer_gridCont__rKrbs{
        justify-content:center; 
        align-items:center;
    }

    .Transfer_buttons__CYVwK{
       margin-top: 10px !important;
    }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px){
    .Transfer_paper__97jXz{
        max-width: 250px; 
        height: 250px; 
        overflow: auto;
        margin-top: 15px; 
    }

    .Transfer_gridCont__rKrbs{
        justify-content:center; 
        align-items:center;
        display: flex;
    }

    .Transfer_buttons__CYVwK{
       margin-top: 8px !important;
    }
}

/*MOBILE*/
@media screen and (max-width:767px){
    .Transfer_paper__97jXz{
        max-width: 250px; 
        min-width: 155px;
        height: 250px; 
        overflow: auto; 
        margin :auto;
        margin-top: 15px;
    }

    .Transfer_gridCont__rKrbs{
        justify-content:center; 
        align-items:center;
        display: flex;
    }

    .Transfer_buttons__CYVwK{
       margin-top: 5px !important;
       width: 8% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/transfer/Transfer.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;OACG,2BAA2B;IAC9B;AACJ;;AAEA,SAAS;AACT;IACI;QACI,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;IACjB;;IAEA;OACG,0BAA0B;IAC7B;AACJ;;AAEA,SAAS;AACT;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;IACjB;;IAEA;OACG,0BAA0B;OAC1B,oBAAoB;IACvB;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .paper{\n        max-width: 300px; \n        height: 300px; \n        overflow: auto; \n        margin-top: 15px;\n    }\n  \n    .gridCont{\n        justify-content:center; \n        align-items:center;\n    }\n\n    .buttons{\n       margin-top: 10px !important;\n    }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px){\n    .paper{\n        max-width: 250px; \n        height: 250px; \n        overflow: auto;\n        margin-top: 15px; \n    }\n\n    .gridCont{\n        justify-content:center; \n        align-items:center;\n        display: flex;\n    }\n\n    .buttons{\n       margin-top: 8px !important;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px){\n    .paper{\n        max-width: 250px; \n        min-width: 155px;\n        height: 250px; \n        overflow: auto; \n        margin :auto;\n        margin-top: 15px;\n    }\n\n    .gridCont{\n        justify-content:center; \n        align-items:center;\n        display: flex;\n    }\n\n    .buttons{\n       margin-top: 5px !important;\n       width: 8% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `Transfer_paper__97jXz`,
	"gridCont": `Transfer_gridCont__rKrbs`,
	"buttons": `Transfer_buttons__CYVwK`
};
export default ___CSS_LOADER_EXPORT___;
